import React, { FC } from 'react';
import classNames from 'classnames';

import Copy, { CopyProps } from 'Src/components/Copy';

import styles from './ModifierBreadCrumbButton.module.scss';

const sectionId = 'ModifierBreadCrumbButton';

interface ModifierBreadCrumbButtonProps {
  ['data-option-id']: string;
  ['data-testid']: string;
  isActive: boolean;
  isFirst: boolean;
  name: string;
  message: string | undefined;
  messageColor: CopyProps['color'];
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const ModifierBreadCrumbButton: FC<ModifierBreadCrumbButtonProps> = ({
  isActive,
  isFirst,
  name,
  message,
  messageColor,
  onClick,
  ...rest
}) => (
   
  <button
    {...rest}
    onClick={onClick}
    className={classNames(styles['root'], {
      [styles['is-first']]: isFirst,
      [styles['is-active']]: isActive,
    })}
  >
    <Copy
      className={styles['name']}
      ellipsis
      fullWidth
      value={name}
      color="textPrimary"
    />
    <Copy
      className={styles['message']}
      color={messageColor}
      value={message}
      singleLine
    />
  </button>
);

export type { ModifierBreadCrumbButtonProps };
export { ModifierBreadCrumbButton, sectionId };
